import { render } from "./GroupsTab.vue?vue&type=template&id=b6e1e3a0"
import script from "./GroupsTab.vue?vue&type=script&lang=js"
export * from "./GroupsTab.vue?vue&type=script&lang=js"
script.render = render

export default script